<template>
  <IconLucideEyeOff />
</template>
